import React from "react";
import classNames from "classnames";

export const OrderFormErrorLabel = ({error}) =>
    error ? (
        <span className={classNames("marketplace-booking-date-error-message", `${error.level}-level`)}>
            {error.message}
        </span>
    ) : null;
